import { usePasswordUpdate } from "./use-password-update";
import { PasswordForm } from "../shared/password-form/password-form.content";
import type { UserPassword } from "@user-management-context/write/domain/types/user";

interface Props {
  onSubmit: (body: UserPassword) => void;
  userId: string;
  token: string;
  email: string;
}

export const PasswordUpdateContent = ({ onSubmit, userId, token, email }: Props) => {
  return (
    <PasswordForm
      title="Veuillez saisir votre nouveau mot de passe pour le compte suivant:"
      onSubmit={onSubmit}
      useFunction={usePasswordUpdate}
      userId={userId}
      token={token}
      email={email}
    />
  );
};
